var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-2 mx-2"},[(!_vm.gameServers)?_c('div',[_vm._v("Loading")]):(_vm.hostsLoadingError)?_c('div',[_vm._v(_vm._s(_vm.hostsLoadingError))]):_vm._l((_vm.hosts),function(host){return _c('host-card',{key:host.alias,attrs:{"host":host}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }